import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Button, Form } from 'reactstrap'
import AnalyzerTypeSelector from './components/AnalyzerTypeSelector'
import AnalyzerTextInput from './components/AnalyzerTextInput'
import AnalyzerTextArea from './components/AnalyzerTextArea'

import ScriptSelectorWrapper from './wrappers/scriptSelectorWrapper'
import ConfigSelectorWrapper from './wrappers/configSelectorWrapper'
import DatasetSelectorWrapper from './wrappers/datasetSelectorWrapper'
import UserSelectorWrapper from './wrappers/userSelectorWrapper'

const AnalyzerForm = ({ onSubmit, isEdit, isDirty, isAdmin }) => {
  const { handleSubmit } = useFormContext()

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <AnalyzerTypeSelector isAdmin={isAdmin} />
      <AnalyzerTextInput name="name" label="Name" maxLength={30} />
      <AnalyzerTextArea name="description" label="Description" />
      <ScriptSelectorWrapper />
      <ConfigSelectorWrapper />
      <DatasetSelectorWrapper />
      <UserSelectorWrapper />

      <div className="mt-3">
        <Button type="submit" color="primary" disabled={isEdit && !isDirty}>
          Save Analyzer
        </Button>
      </div>
    </Form>
  )
}

export default AnalyzerForm
